import { ReactComponent as calendar } from './calendar.svg';
import { ReactComponent as catalog } from './catalog.svg';
import { ReactComponent as dap } from './dap.svg';
import { ReactComponent as edit } from './edit.svg';
import { ReactComponent as progress } from './progress.svg';
import { ReactComponent as remove } from './remove.svg';
import { ReactComponent as slide } from './slide.svg';
import { ReactComponent as close } from './close.svg';
import { ReactComponent as PaperClip } from './paperclip.svg';
import { ReactComponent as MaterialsIcon } from './materials.svg';
import { ReactComponent as EmptyPhotoIcon } from './emptyPhoto.svg';
import { ReactComponent as OrganizationIcon } from './organization.svg';
import { ReactComponent as HamburgerMenu } from './hamburgerMenu.svg';
import { ReactComponent as Gear } from './gear.svg';
import { ReactComponent as Milestones } from './milestones.svg';
import { ReactComponent as BackArrow } from './backArrow.svg';
import { ReactComponent as MailboxIcon } from './mailbox.svg';
import { ReactComponent as EditPencil } from './edit-icon-pencil.svg';
import { ReactComponent as clock } from './clock.svg';
import { ReactComponent as calendarEvent } from './calendarEvent.svg';
import { ReactComponent as folderIcon } from './folder.svg';
import { ReactComponent as resources } from './resources.svg';
import { ReactComponent as resourceDeleted } from './resourceDeletedIcon.svg';
import { ReactComponent as categoryDeleted } from './categoryDeletedIcon.svg';
import { ReactComponent as link } from './link.svg';
import { ReactComponent as Messages } from './message.svg';
import { ReactComponent as back } from './back.svg';
import { ReactComponent as arrowBackIos } from './arrowBackIos.svg';
import { ReactComponent as mail } from './mail.svg';
import { ReactComponent as reinvite } from './reinvite.svg';
import { ReactComponent as sub } from './sub.svg';
import { ReactComponent as help } from './help.svg';
import { ReactComponent as Repeat } from './repeat.svg';
import { ReactComponent as plusQuantity } from './plusQuantity.svg';
import { ReactComponent as portfolio } from './portfolio.svg';
import { ReactComponent as ThreeDots } from './threeDots.svg';
import { ReactComponent as PreviousPage } from './previousPage.svg';
import { ReactComponent as NextPage } from './nextPage.svg';
import { ReactComponent as Ellipsis } from './ellipsis.svg';
import { ReactComponent as deleteConfirmation } from './delete_confirmation.svg';
import { ReactComponent as deleteError } from './delete_error.svg';
import { ReactComponent as playVideo } from './playVideo.svg';
import { ReactComponent as shareIcon } from './share_activity.svg';
import { ReactComponent as scheduleIcon } from './schedule_icon.svg';
import { ReactComponent as addIcon } from './add_green_icon.svg';
import { ReactComponent as createFolderIcon } from './folderIcon.svg';
import { ReactComponent as folderIconV2 } from './folder_icon_v2.svg';
import { ReactComponent as attachIcon } from './attachIcon.svg';
import { ReactComponent as filterIcon } from './filter.svg';

export default {
  close,
  calendar,
  catalog,
  dap,
  edit,
  EditPencil,
  progress,
  remove,
  slide,
  PaperClip,
  Gear,
  MailboxIcon,
  BackArrow,
  Milestones,
  MaterialsIcon,
  HamburgerMenu,
  EmptyPhotoIcon,
  OrganizationIcon,
  clock,
  back,
  calendarEvent,
  folderIcon,
  resources,
  resourceDeleted,
  categoryDeleted,
  link,
  Messages,
  arrowBackIos,
  mail,
  reinvite,
  sub,
  help,
  Repeat,
  plusQuantity,
  portfolio,
  ThreeDots,
  PreviousPage,
  NextPage,
  Ellipsis,
  deleteConfirmation,
  deleteError,
  playVideo,
  shareIcon,
  scheduleIcon,
  addIcon,
  createFolderIcon,
  folderIconV2,
  attachIcon,
  filterIcon,
};
